import type React from "react"
import { useTranslation } from "react-i18next"

import type { Organization } from "@/models/organization"

import { MenuItem } from "@mui/material"

interface SitesExportCsvMenuItemProps {
  endDate?: string
  organizationId: Organization["id"]
  startDate?: string
}

export const SitesExportCsvMenuItem: React.FC<SitesExportCsvMenuItemProps> = ({
  organizationId,
  startDate,
  endDate,
}) => {
  const { t } = useTranslation()
  const isDisabled = !organizationId || !startDate || !endDate

  return (
    <MenuItem
      component={isDisabled ? "button" : "a"}
      disabled={isDisabled}
      href={
        isDisabled
          ? undefined
          : `/api/v1/site_explorer/export_csv?organization_id=${organizationId}&start_date=${startDate}&end_date=${endDate}`
      }
    >
      {t("menuItem.exportCsv", { ns: "common" })}
    </MenuItem>
  )
}
